import React from 'react';

const AlertsManagementCardSkeleton: React.FC = () => {
  return (
    <div className="ssc ssc-card">
      <div className="ssc-hr"></div>
      <div className="ssc-wrapper">
        <div className="ssc-line w-90"></div>
        <div className="ssc-line w-30"></div>
        <div className="ssc-line w-70"></div>
        <div className="flex align-center justify-between">
          <div className="ssc-line w-50"></div>
          <div className="ssc-circle w-30"></div>
        </div>
      </div>
      <div className="ssc-hr"></div>
    </div>
  );
};

export default AlertsManagementCardSkeleton;
